/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S14_I3Inputs */

const tr_kullanim_s14_i3 = /** @type {(inputs: Kullanim_S14_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım Koşulları veya Servis Sözleşmesi'nin esaslı ihlali`)
};

const en_kullanim_s14_i3 = /** @type {(inputs: Kullanim_S14_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material breach of the Terms of Use or the Service Agreement`)
};

const de_kullanim_s14_i3 = /** @type {(inputs: Kullanim_S14_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesentliche Verletzung der Nutzungsbedingungen oder des Servicevertrags`)
};

const ru_kullanim_s14_i3 = /** @type {(inputs: Kullanim_S14_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Существенное нарушение Условий использования или Договора об обслуживании`)
};

/**
* | output |
* | --- |
* | "Material breach of the Terms of Use or the Service Agreement" |
*
* @param {Kullanim_S14_I3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s14_i3 = /** @type {((inputs?: Kullanim_S14_I3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S14_I3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s14_i3(inputs)
	if (locale === "de") return de_kullanim_s14_i3(inputs)
	if (locale === "ru") return ru_kullanim_s14_i3(inputs)
	return tr_kullanim_s14_i3(inputs)
});